import { useEffect } from "react";
import resolveKeyboardKey from "./resolveKeyboardKey";

function inInput(eventTarget: null | EventTarget) {
  if (eventTarget instanceof Element) {
    const nodeName = (eventTarget.nodeName || "undefined").toLowerCase();
    if (
      nodeName === "textarea" ||
      nodeName === "input" ||
      nodeName === "select" ||
      eventTarget.getAttribute("role") === "textbox" ||
      eventTarget.getAttribute("contentEditable") === "true"
    ) {
      return true;
    }
  }
  return false;
}

function contains(
  target: { [index: string]: any },
  partial: { [index: string]: any }
) {
  for (const key in partial) {
    if (
      Object.prototype.hasOwnProperty.call(partial, key) &&
      partial[key] !== target[key]
    ) {
      return false;
    }
  }

  return true;
}

export default function useKeyAction(
  target: Partial<KeyboardEvent> | Partial<KeyboardEvent>[],
  handler: (event: KeyboardEvent) => void,
  allowInput?: boolean
) {
  useEffect(() => {
    function handleShortcut(event: KeyboardEvent) {
      const eventKey = resolveKeyboardKey(event);
      const ts = Array.isArray(target) ? target : [target];
      const match = ts.find((t) => {
        const { key, ...props } = t;
        return key === eventKey && contains(event, props);
      });

      if (match && (!inInput(event.target) || allowInput)) {
        handler(event);
      }
    }

    document.addEventListener("keydown", handleShortcut);
    return () => {
      document.removeEventListener("keydown", handleShortcut);
    };
  }, [target, handler, allowInput]);
}
